import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  Permission,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { getNotas, getNotasByProfissional } from './_requests'
import { NotaList } from './_models'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../../../auth'

const QueryResponseContext = createResponseContext<NotaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()
  const { currentUser } = useAuth()
  const location = useLocation()
  const isProfissionalRoute = location.pathname.includes('/profissional')

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  // Admin lista por instituição: sem ela na busca já aplicada, não consulta (a tabela pede a
  // seleção). Olha o `search` do estado, não o filtro, para não buscar com o filtro antigo.
  const aguardandoEmpresa =
    currentUser?.grupo?.nome === Permission.Admin && !state.search?.includes('fatura.empresa:')

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.NOTAS_LIST, query, isProfissionalRoute],
    () => (isProfissionalRoute ? getNotasByProfissional(query) : getNotas(query)),
    {
      cacheTime: 0,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !isOpen && !aguardandoEmpresa,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{
        isLoading: isFetching,
        isError,
        refetch,
        response: aguardandoEmpresa ? undefined : response,
        query,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
